import React, { useEffect } from 'react';
import { Redirect, Route, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import auth from 'app/api/auth';
import { INTERNAL_CONTEXT, URLS } from 'app/config/urls';
import { SETORES } from '../../../config/sectors';

function PrivateRoute({ component: Component, ...rest }) {
  const history = useHistory();
  const userLogged = useSelector(state => state.auth.user);

  const { path } = rest;

  useEffect(() => {
    (() => {
      if (userLogged && userLogged.setores) {
        if (path && path.indexOf('/interno/lines') >= 0) {
          let linesAdminstrator = false;
          userLogged.setores.forEach(s => {
            if (s.cdOrgaoSetor === SETORES.DPLO) linesAdminstrator = true;
          });
          if (!linesAdminstrator) {
            history.push(INTERNAL_CONTEXT);
          }
        }
      }
    })();
  }, [history, path, userLogged]);

  return (
    <Route
      {...rest}
      render={props =>
        !!auth.getToken() ? <Component {...props} /> : <Redirect to={URLS.LOGIN} />
      }
    />
  );
}

export default PrivateRoute;
